export const version = "solidity/5.8.0";
